import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Money, MyMoney} from "api-client";

const initialState: MyMoney = {
  balanceStats: {
    balance: new Money(0, "RUB"),
    depositSum: new Money(0, "RUB"),
    investedSum: new Money(0, "RUB"),
    returned: new Money(0, "RUB"),
    withdrawn: new Money(0, "RUB"),
    reserved: new Money(0, "RUB"),
    inLoanProjects: new Money(0, "RUB"),
    totalSum: new Money(0, "RUB"),
    free: new Money(0, "RUB"),
  },
  nextRepaymentsSum: {
    days30: new Money(0, "RUB"),
    days60: new Money(0, "RUB"),
    days90: new Money(0, "RUB"),
  },
  portfolioStats: {
    loanPayment: {
      projectCount: 0,
      investmentSum: new Money(0, "RUB"),
      principalPaid: new Money(0, "RUB"),
      principalRemain: new Money(0, "RUB"),
      income: new Money(0, "RUB")
    },
    overdue: {
      projectCount: 0,
      investmentSum: new Money(0, "RUB"),
      principalPaid: new Money(0, "RUB"),
      principalRemain: new Money(0, "RUB"),
      income: new Money(0, "RUB")
    },
    paid: {projectCount: 0,
      investmentSum: new Money(0, "RUB"),
      principalPaid: new Money(0, "RUB"),
      principalRemain: new Money(0, "RUB"),
      income: new Money(0, "RUB")},
  },
  projectSummaryStats: {
    reviewSummary: {projectCount: 0, projectSum: new Money(0, "RUB")},
    fundraisingSummary: {projectCount: 0, projectSum: new Money(0, "RUB")},
    loanPaymentSummary: {projectCount: 0, projectSum: new Money(0, "RUB")},
  },
};

export const myMoneySlice = createSlice({
  name: "my-money",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<MyMoney>) => {
      return {...state, ...action.payload};
    },
  }
});

export const {
  set,
} = myMoneySlice.actions;

export default myMoneySlice.reducer;

